module.exports = __webpack_public_path__ + "static/img/companyProducts1.ed3ed841.png";